import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useI18n } from '../context/I18nContext';

const StarRating = ({ rating }) => {
  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map(star => (
        <span key={star} className={`text-sm ${star <= Math.floor(rating) ? 'text-amber-500' : 'text-gray-300'}`}>
          ★
        </span>
      ))}
      <span className="text-xs text-gray-500 ml-1">{rating}</span>
    </div>
  );
};

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const { t, translateCategory } = useI18n();
  const [imgError, setImgError] = useState(false);
  const [added, setAdded] = useState(false);

  const handleAddToCart = (e) => {
    e.preventDefault();
    addToCart(product, 1);
    setAdded(true);
    setTimeout(() => setAdded(false), 1500);
  };

  const categoryColors = {
    'Dog': 'bg-amber-100 text-amber-800',
    'Cat': 'bg-orange-100 text-orange-800',
    'Wild Animals': 'bg-yellow-100 text-yellow-800',
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden group border border-amber-100">
      <Link to={`/products/${product.id}`}>
        <div className="relative overflow-hidden bg-amber-50 h-56">
          {!imgError ? (
            <img
              src={product.images[0]}
              alt={product.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              onError={() => setImgError(true)}
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <span className="text-6xl">🐾</span>
            </div>
          )}
          <span className={`absolute top-3 left-3 text-xs font-medium px-2 py-1 rounded-full ${categoryColors[product.category] || 'bg-gray-100 text-gray-700'}`}>
            {translateCategory(product.category)}
          </span>
        </div>
      </Link>
      <div className="p-4">
        <Link to={`/products/${product.id}`}>
          <h3 className="font-semibold text-gray-800 hover:text-amber-800 transition-colors mb-1 truncate">
            {product.name}
          </h3>
        </Link>
        <StarRating rating={product.rating} />
        <p className="text-xs text-gray-500 mt-1 mb-3">{t('product.reviews', { count: product.reviews })}</p>
        <div className="flex items-center justify-between">
          <span className="text-lg font-bold text-amber-800">${product.price.toFixed(2)}</span>
          <button
            onClick={handleAddToCart}
            className={`text-sm font-medium px-4 py-2 rounded-lg transition-all duration-200 ${
              added
                ? 'bg-green-500 text-white'
                : 'bg-amber-700 hover:bg-amber-800 text-white'
            }`}
          >
            {added ? `✓ ${t('product.addedToCart')}` : t('product.addToCart')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
